import { Injectable } from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  MenuController,
  ModalController,
  Platform,
  PopoverController,
} from '@ionic/angular';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HardwareBackService {
  private initialized = false;
  private backButtonSubscription?: Subscription;

  constructor(
    private platform: Platform,
    private modalCtrl: ModalController,
    private popCtrl: PopoverController,
    private actionCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
  ) {}

  initializeBackHandler(): void {
    if (this.initialized) return;

    this.initialized = true;

    this.initializeBrowserBack();
    this.initializeAndroidBack();
  }

  private initializeAndroidBack(): void {
    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(9999, async () => {
        await this.closeOverlay();
      });
  }

  private initializeBrowserBack(): void {
    window.addEventListener('popstate', this.handleBrowserBack);
  }

  private handleBrowserBack = async (): Promise<void> => {
    await this.closeOverlay();
  };

  private async closeOverlay(): Promise<boolean> {
    const modal = await this.modalCtrl.getTop();

    if (modal) {
      await modal.dismiss();
      return true;
    }

    const popover = await this.popCtrl.getTop();

    if (popover) {
      await popover.dismiss();
      return true;
    }

    const actionSheet = await this.actionCtrl.getTop();

    if (actionSheet) {
      await actionSheet.dismiss();
      return true;
    }

    const alert = await this.alertCtrl.getTop();

    if (alert) {
      await alert.dismiss();
      return true;
    }

    const menu = await this.menuCtrl.getOpen();

    if (menu) {
      await this.menuCtrl.close();
      return true;
    }

    return false;
  }
}
